module.exports = __webpack_public_path__ + "static/media/upButtonHover.7c75c576.svg";